import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, ShieldCheckIcon, AwardIcon, ThumbsUpIcon, SparklesIcon, GraduationCapIcon } from 'lucide-react';
import { programOptions } from '../data/filterOptions';
interface SidebarProps {
  selectedAreaId: number;
  selectedProgram: number;
  onProgramChange: (programId: number) => void;
}
export function Sidebar({
  selectedAreaId,
  selectedProgram,
  onProgramChange
}: SidebarProps) {
  const [openSection, setOpenSection] = useState<string | null>('popularity');
  const toggleSection = (section: string) => {
    setOpenSection(openSection === section ? null : section);
  };
  // Special case: For General area (9), show all "General" programs from other areas
  const programs = selectedAreaId === 9 ? [{
    value: 100,
    label: 'All Business & Finance Programs'
  }, {
    value: 200,
    label: 'All Criminal Justice & Legal Services Programs'
  }, {
    value: 300,
    label: 'All Psychology & Counseling Programs'
  }, {
    value: 400,
    label: 'All Computers & IT Programs'
  }, {
    value: 500,
    label: 'All Healthcare & Medical Assisting Programs'
  }, {
    value: 600,
    label: 'All Education & Teaching Programs'
  }, {
    value: 700,
    label: 'All Trade, Vocational, Career Programs'
  }, {
    value: 800,
    label: 'All Liberal Arts Programs'
  }, {
    value: 900,
    label: 'General/Undecided'
  }, {
    value: 1000,
    label: 'All Nursing Programs'
  }, {
    value: 1100,
    label: 'All Media & Communications Programs'
  }, {
    value: 1200,
    label: 'All Visual Arts & Graphic Design Programs'
  }, {
    value: 1300,
    label: 'All Religious Studies Programs'
  }] : programOptions[selectedAreaId] || [];
  return <div className="w-full space-y-4 sticky top-24" data-id="element-731" data-mp="20nid8qar21hk">
      {/* Methodology Box */}
      <div className="bg-gray-50 rounded-lg border border-gray-200 p-4" data-id="element-732" data-mp="k9s77e02l35a">
        <h3 className="text-sm font-bold text-gray-900 mb-1" data-id="element-733" data-mp="p9ektojt8lem">Total Score</h3>
        <p className="text-xs text-gray-600 mb-4 leading-relaxed" data-id="element-734" data-mp="paplvglvff21">
          Our scores combine the following 3 components:
        </p>

        <div className="space-y-2" data-id="element-735" data-mp="2lzr3opyos2ga">
          <div className="border-b border-gray-200 pb-2" data-id="element-736" data-mp="2m0sbmlkeo8ts">
            <button onClick={() => toggleSection('popularity')} className="w-full flex items-center justify-between text-left text-xs font-bold text-gray-900 hover:text-[#3b82f6] transition-colors" data-id="element-737" data-mp="2h8itvstg2f2l">
              <div className="flex items-center gap-1.5" data-id="element-738" data-mp="287t1kz3e76tm">
                <ThumbsUpIcon className="w-3.5 h-3.5 text-[#22c55e]" data-id="element-739" data-mp="289duyldz0jpw" />
                Popularity
              </div>
              {openSection === 'popularity' ? <ChevronUpIcon className="w-3.5 h-3.5" data-id="element-740" data-mp="1y9d7qoczdjgf" /> : <ChevronDownIcon className="w-3.5 h-3.5" data-id="element-741" data-mp="1ya6hly78kp2s" />}
            </button>
            {openSection === 'popularity' && <p className="text-xs text-gray-600 mt-1.5 pl-5 leading-relaxed" data-id="element-742" data-mp="1uae6bdqgk4tq">
                Based on user interest and click-through rates.
              </p>}
          </div>

          <div className="border-b border-gray-200 pb-2" data-id="element-743" data-mp="3omu8a2c80wss">
            <button onClick={() => toggleSection('reputation')} className="w-full flex items-center justify-between text-left text-xs font-bold text-gray-900 hover:text-[#3b82f6] transition-colors" data-id="element-744" data-mp="1af33tevtlm3y">
              <div className="flex items-center gap-1.5" data-id="element-745" data-mp="1k3ur39pxri8j">
                <AwardIcon className="w-3.5 h-3.5 text-[#22c55e]" data-id="element-746" data-mp="1k6hac6m6vm6l" />
                Brand Reputation
              </div>
              {openSection === 'reputation' ? <ChevronUpIcon className="w-3.5 h-3.5" data-id="element-747" data-mp="rgh3i284nz13" /> : <ChevronDownIcon className="w-3.5 h-3.5" data-id="element-748" data-mp="rhjusb9d43hj" />}
            </button>
            {openSection === 'reputation' && <p className="text-xs text-gray-600 mt-1.5 pl-5 leading-relaxed" data-id="element-749" data-mp="wgmy9r9p21ne">
                Accreditation status and industry recognition.
              </p>}
          </div>

          <div className="pb-0.5" data-id="element-750" data-mp="15h1kcsuhfkry">
            <button onClick={() => toggleSection('features')} className="w-full flex items-center justify-between text-left text-xs font-bold text-gray-900 hover:text-[#3b82f6] transition-colors" data-id="element-751" data-mp="2bvkd1hyfgoh4">
              <div className="flex items-center gap-1.5" data-id="element-752" data-mp="2fdghr4fkuq0u">
                <SparklesIcon className="w-3.5 h-3.5 text-[#22c55e]" data-id="element-753" data-mp="2fdzzak1bfcec" />
                Features & Benefits
              </div>
              {openSection === 'features' ? <ChevronUpIcon className="w-3.5 h-3.5" data-id="element-754" data-mp="2oeo2skt31ucz" /> : <ChevronDownIcon className="w-3.5 h-3.5" data-id="element-755" data-mp="2ofppjmjgo5aj" />}
            </button>
            {openSection === 'features' && <p className="text-xs text-gray-600 mt-1.5 pl-5 leading-relaxed" data-id="element-756" data-mp="2kb9njwcyxi0l">
                Program flexibility, transfer credits, and support services.
              </p>}
          </div>
        </div>
      </div>

      {/* Other Programs Available */}
      {programs.length > 0 && <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-757" data-mp="380u6wgd1ahae">
          <div className="flex items-center gap-2 mb-3" data-id="element-758" data-mp="332iz0b6augut">
            <GraduationCapIcon className="w-4 h-4 text-[#3b82f6]" data-id="element-759" data-mp="3355d6tnp3um0" />
            <h4 className="text-xs font-bold text-gray-900 uppercase tracking-wider" data-id="element-760" data-mp="3h3ln0tguu18d">
              Other Programs
            </h4>
          </div>
          <ul className="space-y-1" data-id="element-761" data-mp="3vpixy4fxfgxz">
            {programs.map(program => <li key={program.value} data-id="element-762" data-mp="3vq24kp04miwp">
                <button onClick={() => onProgramChange(program.value)} className={`w-full text-left px-2.5 py-2 rounded-md text-xs transition-colors ${selectedProgram === program.value ? 'bg-blue-50 text-[#3b82f6] font-semibold' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-763" data-mp="4j7uk1ng243h">
                  {program.label}
                </button>
              </li>)}
          </ul>
        </div>}
    </div>;
}